module.exports = __webpack_public_path__ + "static/img/banner_green.b324ccfd.png";